import { themeStyleElementId } from "@/modules/theme/cssLoader.ts";
import { notNull } from "@warrenio/utils/notNull";
import { atom } from "jotai/vanilla";

export const themeCssHtmlAtom = atom(() => {
    // const themeCss = get(themeCssAtom);
    // return `<style id="theme-css">${themeCss}</style>`;
    return notNull(document.getElementById(themeStyleElementId), "theme element").outerHTML;
});
